import { IHubEventBasicFormValidationState } from './contracts'
import { NotEmpty, Sections, ShortText, Title } from 'sharedKernel/validations/'
import { Youtube } from 'sharedKernel/validations/specific/youtube'

export const EVENT_BASIC_FORM_VALIDATIONS_SET_STATE = 'EVENT_BASIC_FORM_VALIDATIONS_SET_STATE'
export const EVENT_BASIC_FORM_VALIDATIONS_STATE: IHubEventBasicFormValidationState = {
  name: {
    isValid: true,
    message: '',
    validations: [
      {
        stages: ['save', 'launch'],
        validation: new NotEmpty()
      }
    ]
  },
  startDate: {
    isValid: true,
    message: '',
    validations: [
      {
        stages: ['save', 'launch'],
        validation: new NotEmpty()
      }
    ]
  },
  startTime: {
    isValid: true,
    message: '',
    validations: [
      {
        stages: ['save', 'launch'],
        validation: new NotEmpty()
      }
    ]
  },
  endDate: {
    isValid: true,
    message: '',
    validations: []
  },
  endTime: {
    isValid: true,
    message: '',
    validations: []
  },
  ticketDescription: {
    isValid: true,
    message: '',
    validations: []
  },
  website: {
    isValid: true,
    message: '',
    validations: []
  },
  description: {
    isValid: true,
    message: '',
    validations: [
      {
        stages: ['save', 'launch'],
        validation: new ShortText()
      }
    ]
  }
}

export const EVENT_BASIC_FORM_VALIDATIONS_INITIAL_STATE: IHubEventBasicFormValidationState = {
  name: {
    isValid: true,
    message: '',
    validations: []
  },
  startDate: {
    isValid: true,
    message: '',
    validations: []
  },
  startTime: {
    isValid: true,
    message: '',
    validations: []
  },
  endDate: {
    isValid: true,
    message: '',
    validations: []
  },
  endTime: {
    isValid: true,
    message: '',
    validations: []
  },
  ticketDescription: {
    isValid: true,
    message: '',
    validations: []
  },
  website: {
    isValid: true,
    message: '',
    validations: []
  },
  description: {
    isValid: true,
    message: '',
    validations: []
  }
}

const HubEventBasicFormValidationSetState = (payload?: IHubEventBasicFormValidationState): any => {
  return {
    type: EVENT_BASIC_FORM_VALIDATIONS_SET_STATE,
    payload: payload
  }
}

export { HubEventBasicFormValidationSetState }
